import React, { useState, useCallback } from 'react';
import Button from './Buttons/Button';
import ScrollWrapper from './ScrollWrapper';

/*  Helper for Modals */
export const useModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const openModal = useCallback((content) => {
        setModalContent(content);
        setIsModalOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setModalContent(null);
        setIsModalOpen(false);
    }, []);

    const ModalView = useCallback(
        ({ classNames = "w-full h-full", modalColor = "bg-white", hasCloseButton = true }) =>
            isModalOpen ? (
                <div className="h-full fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-10">
                    <div className={`${modalColor} p-5 rounded-xl shadow-md relative flex flex-col max-h-[85vh] min-h-0 ${classNames}`}>
                        {hasCloseButton && (
                            <Button
                                onClickAction={closeModal}
                                iconName={"cross.svg"}
                                classNames='w-9 h-9 absolute top-2 right-2 p-2 border-0 z-10'
                                buttonColor={modalColor === "bg-white" ? 'transparent' : 'bg-white'}
                            />
                        )}
                        <div className="flex-1 min-h-0 overflow-hidden">
                            <ScrollWrapper>{modalContent}</ScrollWrapper>
                        </div>
                    </div>
                </div>
            ) : null,
        [isModalOpen, modalContent, closeModal]
    );

    return { ModalView, openModal, closeModal };
};